import { render, staticRenderFns } from "./DashboardNurse.vue?vue&type=template&id=41185f2e&"
import script from "./DashboardNurse.vue?vue&type=script&lang=js&"
export * from "./DashboardNurse.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNurse.vue?vue&type=style&index=0&id=41185f2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports